/*
  © 2025 KondaSoft
  https://www.kondasoft.com
*/

class NumberedSlider extends HTMLElement {
  constructor() {
    super();

    this.navInputs = this.querySelectorAll('.numbered-slider-nav input');
    this.track = this.querySelector('.numbered-slider-track');
    this.currentIndex = 0;

    this.handleNavInputChange();
    this.handleTouch();
    this.handleSlidesAccessibility();
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.navInputs.length) % this.navInputs.length;
    this.update();
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.navInputs.length;
    this.update();
  }

  go(index) {
    this.currentIndex = index;
    this.update();
  }

  update() {
    const offset = -this.currentIndex * 100;
    this.track.style.transform = `translateX(${offset}%)`;

    this.navInputs.forEach((input, index) => {
      input.checked = index === this.currentIndex;
    });

    this.handleSlidesAccessibility();
  }

  handleNavInputChange() {
    this.navInputs.forEach((input, index) => {
      input.addEventListener('change', (event) => {
        event.preventDefault();
        this.go(index);
      });
    });
  }

  handleTouch() {
    let startX = 0;
    let endX = 0;

    this.track.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
    });

    this.track.addEventListener("touchmove", (e) => {
      endX = e.touches[0].clientX;
    });

    this.track.addEventListener("touchend", () => {
      if (!startX || !endX) return;
      const swipeDistance = startX - endX;

      if (swipeDistance > 10) {
        this.next();
      } else if (swipeDistance < -10) {
        this.prev();
      }
    });
  }

  handleSlidesAccessibility() {
    this.querySelectorAll('.numbered-slider-item').forEach((item, i) => {
      if (i === this.currentIndex) {
        item.removeAttribute("aria-hidden");
        item.removeAttribute("tabindex");
        item.querySelectorAll("a, button").forEach((el) => {
          el.removeAttribute("tabindex");
        });
      } else {
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
        item.querySelectorAll("a, button").forEach((el) => {
          el.setAttribute("tabindex", "-1");
        });
      }
    });
  }
}
customElements.define('numbered-slider', NumberedSlider);
